import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { DeleteChannelBan } from "../schemas/schemas_0";
export { $Command };
export class DeleteChannelBanCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [getEndpointPlugin(config, Command.getEndpointParameterInstructions())];
})
    .s("ChimeMessagingService", "DeleteChannelBan", {})
    .n("ChimeSDKMessagingClient", "DeleteChannelBanCommand")
    .sc(DeleteChannelBan)
    .build() {
}
